import { render, staticRenderFns } from "./globalLoad.vue?vue&type=template&id=5729b8cb&scoped=true&"
import script from "./globalLoad.vue?vue&type=script&lang=ts&"
export * from "./globalLoad.vue?vue&type=script&lang=ts&"
import style0 from "./globalLoad.vue?vue&type=style&index=0&id=5729b8cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5729b8cb",
  null
  
)

component.options.__file = "globalLoad.vue"
export default component.exports